import { portalLocale } from "./i18n/portal.js";
/**
 * Money on screen.
 *
 * Integer minor units plus an explicit currency, all the way to the pixel (ADR 0014). The
 * console never divides by 100 into a float and never renders a bare number with a symbol
 * glued on — `Intl.NumberFormat` is handed the currency the `Money` value carries, so a
 * value that ever stops being EUR renders as that currency rather than as a lie.
 *
 * AMENDED 2026-10-12 (plan-017 WAPP-A, design §29.11, owner answer OQ-1): the console no longer
 * quotes one published rate. Every price on screen is the organization's own talk rate for the
 * kind of conversation in question, read through `useTalkRates` (`./api/slice/talk-rate.ts`) and
 * worded by `talkRateText` — never a constant here.
 */
import type { Money } from "@wetalk/domain";
import { moneyText, wholeMoneyText } from "@wetalk/view-model/money";

/** Moved to `@wetalk/view-model/money` (plan-034 VIEW-PKG); re-exported here so no portal importer changes. */
export { formatDuration, formatTrialRemaining } from "@wetalk/view-model/money";

/** `€27.40`. Always two decimals — a total that reads `€27.4` looks like a bug. In the portal's display language. */
export function formatMoney(amount: Money): string {
  return moneyText(portalLocale(), amount);
}

/** `€12` — whole units only (an hourly rate, a round amount); cents only when there are any. */
export function formatWholeMoney(amount: Money): string {
  return wholeMoneyText(portalLocale(), amount);
}
